module.exports = __webpack_public_path__ + "img/baner-audi-select-plus.3cabc937.png";